import React from 'react';
import { Link } from 'react-router-dom';
import Loader from './Loader'
import SkynetIcon from "./Fundamentals/SkynetIcon";

const PanelActions = ({ editLink, onRefresh, editCustomerLayout }) => {
    
return  <div>
            <Loader />
            {editCustomerLayout ? <Link to={editCustomerLayout}><span className="vismaicon vismaicon-panel pull-right cursorpointer" title="Layout" /></Link> : <></>}
            <Link to={editLink}><SkynetIcon title={"Edit"} icon={"vismaicon-edit"}></SkynetIcon></Link>
            <SkynetIcon icon={"vismaicon-refresh"} onClick={() => onRefresh()}></SkynetIcon>
        </div>
}

export default PanelActions;